import { Grid, makeStyles, Theme } from "@material-ui/core";
import { DefaultInfo } from "components/NothingRight";
import useText from "constants/text";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import React, { useEffect, useState } from "react";
import NTCollipsableStops from "../NationalTransport/Collapse";
import { RightSideSamaPapserContainer } from "./MainStyles";
import SchedulingDetails from "./RightSideComponents/components/SchedulingDetails";

export const requestContainerBgColor = {
  MAD: "252, 254, 255",
  NT: "194,202,236",
  TR: "202, 234, 195",
};

export const useStyles = makeStyles((theme: Theme) => ({
  hr: {
    width: "65%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      width: "72%",
    },
  },
  gridContainer: {
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: { flexWrap: "wrap" },
  },
  hr2: {
    width: "76%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
  },
  hr3: {
    width: "69%",
    backgroundColor: "rgba(57, 158, 191, 0.2)",
    height: "2px",
    border: "none",
    [theme.breakpoints.down("xs")]: {
      width: "72%",
    },
  },
  p: {
    color: "#757a93",
    fontSize: "14px",
    marginLeft: "0",
    height: "83px",
    padding: "0 28px 0 0",
    fontStyle: "normal",
    textAlign: "justify",
    fontFamily: "Montserrat",
    fontWeight: "normal",
    lineHeight: 1.79,
    fontStretch: "normal",
    letterSpacing: "normal",
    marginTop: "-10px",
  },
  gridStyle: {
    display: "flex",
    alignItems: "center",
    color: "#399ebf",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 10,
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
    },
  },
}));

export default function NTSideDetails() {
  const { requestQuoteNT, step } = React.useContext(NewRequestQuoteContext);
  const [requestToDisplay, setRequestToDisplay] = useState<any>(null);
  const { text } = useText();
  const styles = useStyles();
  useEffect(() => {
    setRequestToDisplay(requestQuoteNT);
    // eslint-disable-next-line
  }, [requestQuoteNT]);
  return (
    <RightSideSamaPapserContainer>
      {requestToDisplay?.stops?.length && step !== 3 ? (
        <>
          <Grid container spacing={1}>
            <Grid item xs={12} className={styles.gridStyle}>
              National transport
              <hr className={styles.hr} />
            </Grid>
            <Grid item xs={12}>
              <NTCollipsableStops requestQuoteNT={requestToDisplay} />
            </Grid>
            {requestToDisplay?.productType?.length && (
              <Grid item xs={12}>
                
                <SchedulingDetails requestToDisplay={requestToDisplay} isDisabled />
              </Grid>
            )}
            {requestToDisplay?.additionnalInfos && (
              <>
                <Grid item xs={12} className={styles.gridStyle}>
                  {text.all.additional_infos}
                  <hr className={styles.hr3} />
                </Grid>
                <Grid item xs={12}>
                  <p className={styles.p}>{requestToDisplay?.additionnalInfos}</p>
                </Grid>
              </>
            )}
          </Grid>
        </>
      ) : (
        <DefaultInfo />
      )}
    </RightSideSamaPapserContainer>
  );
}
